import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from '../common/services/localStorage.service';
import { DUES_LOCK_STORAGE_KEY } from '../common/enums/dues-lock.enum';

@Injectable()
export class CollectionInfrastructureHelperService {
  constructor(
    private _router: Router,
    private _localStorage: LocalStorageService
  ) {}

  redirectToSubscriptionPage(): void {
    this._localStorage.remove('invoice');
    this._router.navigate(['/pending-payment'], {
      queryParams: {
        subscription: this.isNegativeBalance() ? 0 : 1,
      },
    });
  }

  removeCollectionInfra(): void {
    this._localStorage.remove('restaurant_id');
    this._localStorage.remove('subscription');
    this._localStorage.remove('planType');
    this._localStorage.remove('nbBannerType');
    this._localStorage.remove('isBalanceExpired');
    this._localStorage.remove('isPlanExpired');
    this._localStorage.remove('planType');
    this._localStorage.remove('blockFeatureList');
    this._localStorage.remove('isPlanLocked');
    this._localStorage.remove(DUES_LOCK_STORAGE_KEY);
  }
  isPlanExpired(): boolean {
    try {
      if (this._router.url.includes('hq')) {
        return false;
      } else {
        const parseOrFalse = (value: string | null) => {
          if (value === 'undefined' || value === 'null' || value === null) {
            return false;
          }
          return JSON.parse(value);
        };

        const isPlanExpired = parseOrFalse(
          this._localStorage.get('isPlanExpired')
        );
        const isBalanceExpired = parseOrFalse(
          this._localStorage.get('isBalanceExpired')
        );
        return isPlanExpired || isBalanceExpired;
      }
    } catch (error) {
      console.error('Error parsing plan expired from localStorage:', error);
      return false;
    }
  }
  isNegativeBalance(): boolean {
    try {
      if (this._router.url.includes('hq')) {
        return false;
      } else {
        const isNegative = this._localStorage.get('negativeBalance');
        if (isNegative !== 'undefined' && isNegative !== 'null' && isNegative) {
          return JSON.parse(isNegative);
        } else {
          return false;
        }
      }
    } catch (error) {
      console.error('Error parsing plan expired from localStorage:', error);
      return false;
    }
  }
  isSubscription(): boolean {
    try {
      if (this._router.url.includes('hq')) {
        return false;
      } else {
        const isSubs = this._localStorage.get('subscription');
        if (isSubs !== 'undefined' && isSubs !== 'null' && isSubs) {
          return JSON.parse(isSubs);
        } else {
          return false;
        }
      }
    } catch (error) {
      console.error('Error parsing plan expired from localStorage:', error);
      return false;
    }
  }
  getBlockedFeatures() {
    try {
      if (this._router.url.includes('hq')) {
        return [];
      } else {
        const blockFeatureList = this._localStorage.get('blockFeatureList');
        if (
          blockFeatureList !== 'undefined' &&
          blockFeatureList !== 'null' &&
          blockFeatureList
        ) {
          return JSON.parse(blockFeatureList);
        } else {
          return [];
        }
      }
    } catch (error) {
      console.error('Error parsing blocked features from localStorage:', error);
      return [];
    }
  }
}
